import { IEventBus } from 'components/eventBus/IEventBus';

import { TLogLevel } from './ILogger';
import { ELoggerEvents, TLoggerEvents } from './Logger.events';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TLogMethod = (message: string, payload?: Record<string, any>) => void;

const abstractLogger: (
  eventBus: IEventBus<TLoggerEvents>,
  domain: string,
  level: TLogLevel,
) => TLogMethod = (eventBus, domain, level) => (message, payload) => {
  eventBus.publish(ELoggerEvents.LOG, {
    domain,
    timestamp: performance.now(),
    level: level,
    message,
    payload,
  });
};

export const Logger: (
  eventBus: IEventBus<TLoggerEvents>,
  domain: string,
) => Record<TLogLevel, TLogMethod> = (eventBus, rawDomain) => {
  const domain: string = `${rawDomain}{${(Math.random() + 1).toString(36).substring(2, 6)}}`;

  return {
    debug: abstractLogger(eventBus, domain, 'debug'),
    verbose: abstractLogger(eventBus, domain, 'verbose'),
    info: abstractLogger(eventBus, domain, 'info'),
    warn: abstractLogger(eventBus, domain, 'warn'),
    error: abstractLogger(eventBus, domain, 'error'),
    fatal: abstractLogger(eventBus, domain, 'fatal'),
  };
};

export type TLogger = ReturnType<typeof Logger>;
